import React from 'react'
import {
  Alert,
  Box,
  Label,
  RadioButton,
  TextBody,
  TextHeading,
  get,
} from '@ally/metronome-ui'
import { RadioGroup } from '@ally/forms'
import styled from 'styled-components'
import { GENERIC_ERROR_MESSAGE } from '../../../utils/constants'

const StyledAlert = styled(Alert)`
  margin-bottom: ${get.space('md')};
`
export const OwnershipTypeField: React.FC<{
  modalView?: boolean
  showErrorMessage?: boolean
  handleOwnershipTypeChange?: (name: string, selected: string) => void
  handleOwnershipTypeChangeFromExisting?: (value: string) => void
}> = ({
  modalView,
  showErrorMessage,
  handleOwnershipTypeChange,
  handleOwnershipTypeChangeFromExisting,
}) => {
  const handleChange = (selected: string): void => {
    if (handleOwnershipTypeChangeFromExisting) {
      handleOwnershipTypeChangeFromExisting(selected)
    }
    if (handleOwnershipTypeChange) {
      handleOwnershipTypeChange('ownershipType', selected)
    }
  }
  return (
    <>
      {modalView ? (
        <TextHeading
          tag="h1"
          size="sm"
          weight="bold"
          tabIndex={-1}
          id="add-bene-heading"
          data-testid="accountOwnershipModalHeading"
        >
          Account ownership type
        </TextHeading>
      ) : (
        <Label htmlFor="ownershipType" data-testid="ownershipTypeFieldLabel">
          Account Ownership Type
        </Label>
      )}
      {modalView && (
        <Box mt="sm" mb="md">
          <TextBody tag="span" size="sm">
            Update the account ownership type for this account.
          </TextBody>
        </Box>
      )}
      {showErrorMessage && (
        <StyledAlert
          variant="error"
          focusOnMount
          disableContainer
          body={GENERIC_ERROR_MESSAGE}
        />
      )}

      <RadioGroup
        name="ownershipType"
        legendText=""
        isLegendHidden
        defaultValue="I"
        onChange={(selected): void => handleChange(selected)}
      >
        <RadioButton
          label="In trust for"
          value="I"
          data-testid="in-trust-for"
        />
        <RadioButton
          label="Payable on death"
          value="D"
          data-testid="payable-on-death"
        />
      </RadioGroup>
    </>
  )
}
